import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/utilities/core/cn";
import type { Media } from "@/payload-types";
type MediaCreditProps = {
  media: Media | null | undefined;
  className?: string;
};

/**
 * Renders the source credit line for a Media item when the image originated
 * from a known external provider. Returns `null` for media without such
 * metadata, so it is safe to drop into any image render site unconditionally.
 *
 * Currently supports: IMAGO (set via `imagoMeta` by the IMAGO picker).
 */
export function MediaCredit(t0) {
  const $ = _c(4);
  const {
    media,
    className
  } = t0;
  if (!media?.imagoMeta) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("text-xs text-muted-foreground", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className={t1}>Image: IMAGO</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}